export const ITEMS_PER_PAGE = 20;



// WEBPACK FOOTER //
// ./src/app/shared/constants/pagination.constants.ts